import {useQueryClient} from '@tanstack/react-query'
import * as React from 'react'
import {logger} from 'tizra'
import * as B from '../block'
import {Admin} from './admin'
import {meta} from './meta'
import {ReactQueryDevtools} from './safe-react-query-devtools'

const log = logger('GlobalBlock')

export const GlobalBlock = B.blockWithInfo(
  {...meta, wrapperDiv: false, Admin},
  () => {
    return (
      <>
        <ReactQueryDevtools />
        {useLoginLogout(B.useAuthConfig())}
        {useSessionErrors()}
      </>
    )
  },
)

const authConfigKeys = {
  register: 'registration',
  resetPassword: 'passwordReset',
  signin: 'signin',
} as const

function useLoginLogout(authConfig: ReturnType<typeof B.useAuthConfig>) {
  const props = B.SignInModal.useProps()
  const {show} = props.store
  const queryClient = useQueryClient()

  React.useEffect(() => {
    log.debug?.('in useLoginLogout effect')

    Object.assign<Window['tizra'], Partial<Window['tizra']>>(window.tizra, {
      login: (view = 'signin') => {
        if (view === 'signin' && authConfig.authAgent === 'sso') {
          window.location.assign('/api/sso-redirect')
          return
        }
        if (view === 'signin' && window.tizra.customLoginUrl) {
          window.location.assign(window.tizra.customLoginUrl)
          return
        }
        const k = authConfigKeys[view]
        if (!k) {
          log.error('unknown view', view)
          return
        }
        if (authConfig.modal.enabled) {
          show(view)
        } else {
          const [url, params = ''] = authConfig[k].url.split('?', 2)
          const usp = new URLSearchParams(params)
          usp.set(
            'successUrl',
            window.location.pathname +
              window.location.search +
              window.location.hash,
          )
          window.location.assign(url + '?' + usp)
        }
      },
      logout: () => {
        window.location.assign(
          window.tizra.customLogoutUrl ||
            '/authcallback/_/internal?operation=logout',
        )
      },
      registerUser: () => {
        window.tizra.login('register')
      },
      resetPassword: () => {
        window.tizra.login('resetPassword')
      },
    })
  }, [authConfig, queryClient, show])

  return <B.SignInModal authConfig={authConfig} {...props} />
}

function useSessionErrors() {
  const {sessionErrors} = B.useBlockContext()
  const store = B.SessionErrorsModal.useStore({
    defaultOpen: !!sessionErrors.length,
  })
  return <B.SessionErrorsModal store={store} sessionErrors={sessionErrors} />
}
